//import { useCallback, useState } from 'react';
import { Button, Form, Input, Checkbox, Select, DatePicker, InputNumber } from 'antd';
//import AgentList from '../AgentList';
import { getAgentReceiptList, ReceiptPayload } from 'api/receipt';
import { useCallback, useMemo, useState } from 'react';
import AgentReceiptList from '../AgentReceiptList';
import { FileExcelFilled } from '@ant-design/icons';
import xlsx from 'json-as-xlsx';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import moment from 'moment';
import { handleOnlyNumber } from 'features/nach/utils/handleOnlyNumber';

const dateFormat = 'DD/MM/YYYY';
// type Props = {
//   isLoading: boolean;
//   onSubmit: (values: ReceiptPayload) => Promise<void>;
// };

function getFullDate(date: string) {
  if (date != null) {
    const dateMoment = moment(new Date(date)).format('YYYY/DD/MM HH:mm:ss');
    return dateMoment;
  }
}

const filterPayload: ReceiptPayload = {};

const AgentReceiptDashboard = () => {
  const { Option } = Select;

  const [form] = Form.useForm<ReceiptPayload>();
  const [filter, setFilter] = useState(filterPayload);
  const [isDedupeChecked, setDedupeChecked] = useState(false);
  const [onlyDigitError, setOnlyDigitError] = useState(false);
  // const [isDedupe, SetDedupe] = useState(false);
  // const isAdmin = sessionStorage.getItem('isAdmin');
  //applicantPayload.paymentPurpose = form.getFieldValue('paymentPurpose')?.toString();

  const handleSubmit = useCallback(async () => {
    // Get the current values from the form
    const currentValues = form.getFieldsValue();

    if (currentValues.DedupeFromDate) {
      currentValues.DedupeFromDate =
        moment(currentValues.DedupeFromDate).format('YYYY-MM-DD') + ' 00:00:00';
    }
    if (currentValues.DedupeToDate) {
      currentValues.DedupeToDate =
        moment(currentValues.DedupeToDate).format('YYYY-MM-DD') + ' 00:00:00';
    }

    if (currentValues.FromDate) {
      currentValues.FromDate = moment(currentValues.FromDate).format('YYYY-MM-DD') + ' 00:00:00';
    }

    if (currentValues.ToDate) {
      currentValues.ToDate = moment(currentValues.ToDate).format('YYYY-MM-DD') + ' 00:00:00';
    }
    Object.keys(currentValues).forEach((key) => {
      const typedKey = key as keyof ReceiptPayload; // Cast the key to a valid key of FilterPayload
      if (currentValues[typedKey] === '') {
        currentValues[typedKey] = null;
      }
    });
    // Update the filter state with the current values and IsDedupe
    setFilter({
      ...currentValues,
      IsDedupe: isDedupeChecked ? 1 : 0, // Include the current dedupe state
    });
    console.log(currentValues); // Log current values for debugging
    //await onSubmit({ ...currentValues, IsDedupe: isDedupeChecked ? 1 : 0 }); // Pass updated values to the onSubmit function
  }, [form, isDedupeChecked]);

  // function handleDownload(_e: any) {
  //   filter.IsExtract = true;
  //   // getPaymentReport(filter).then((_x) => {
  //   //   // download(_x.data.data);
  //   // });

  //   getAgentReceiptList(filter).then((_x) => {
  //     if (isAdmin != 'true') {
  //       filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  //     }

  //     let settings = {
  //       fileName: 'ReceiptDashboard-Report', // Name of the resulting spreadsheet
  //       extraLength: 3, // A bigger number means that columns will be wider
  //       writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
  //       writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
  //       //RTL: true, // Display the columns from right-to-left (the default value is false)
  //     };

  //     let data = [
  //       {
  //         sheet: 'Sheet 1',
  //         columns: [
  //           { label: 'ROWNUM', value: 'ROWNUM' },
  //           { label: 'LANumber', value: 'LANumber' },
  //           { label: 'PaymentRequestID', value: 'PaymentRequestId' },
  //           { label: 'LoanType', value: 'LoanType' },
  //           { label: 'Amount', value: 'Amount' },
  //           { label: 'RequestStatus', value: 'RequestStatus' },
  //           { label: 'SourceApplicationName', value: 'SourceApplicationName' },
  //           { label: 'Currency', value: 'Currency' },
  //           { label: 'SessionID', value: 'SessionID' },
  //           { label: 'PaymentPurpose', value: 'PaymentPurpose' },
  //           { label: 'PaymentRequestDateTime', value: 'PaymentRequestDateTime' },
  //           { label: 'Mode', value: 'Mode' },
  //           { label: 'RefTransaction', value: 'RefTransaction' },
  //           { label: 'PaymentRef', value: 'paymentRef' },
  //           { label: 'BankCode', value: 'bankCode' },
  //           { label: 'ValueDate', value: 'ValueDate' },
  //           { label: 'FavourName', value: 'FavourName' },
  //           { label: 'Remarks', value: 'remarks' },
  //           { label: 'FundingAccount', value: 'FundingAccount' },
  //           { label: 'PaymentRequestError', value: 'PaymentRequestError' },
  //           { label: 'ByAgent', value: 'ByAgent' },
  //           { label: 'VerificationReason', value: 'verificationReason' },
  //           { label: 'ConfirmRejectStatus', value: 'ConfirmRejectStatus' },
  //         ],

  //         content: _x.data.data,
  //       },
  //     ];
  //     xlsx(data, settings);
  //   });
  // }

  function handleDownload(_e: any) {
    filter.IsExtract = true;
    filter.PageNo = 1;
    filter.PageSize = 10;

    // const values: any = form.getFieldsValue();
    // const filteredValues: any = {
    //   ...values,
    // };

    getAgentReceiptList(filter).then((_x) => {
      let settings = {
        fileName: 'ReceiptDashboard-Report', // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };
      const content = _x.data?.data || [];
      const updatedData = content.map((item: any, index) => ({
        ...item,
        PaymentRequestDateTime: getFullDate(item.PaymentRequestDateTime),
        ValueDate: getFullDate(item.ValueDate),
        ROWNUM: index + 1,
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'LANumber', value: 'LANumber' },
            { label: 'PaymentRequestID', value: 'PaymentRequestId' },
            { label: 'LoanType', value: 'LoanType' },
            { label: 'Amount', value: 'Amount' },
            { label: 'RequestStatus', value: 'RequestStatus' },
            { label: 'SourceApplicationName', value: 'SourceApplicationName' },
            { label: 'Currency', value: 'Currency' },
            { label: 'SessionID', value: 'sessionId' },
            { label: 'PaymentPurpose', value: 'PaymentPurpose' },
            { label: 'PaymentRequestDateTime', value: 'PaymentRequestDateTime' },
            { label: 'Mode', value: 'Mode' },
            { label: 'RefTransaction', value: 'RefTransaction' },
            { label: 'PaymentRef', value: 'paymentRef' },
            { label: 'BankCode', value: 'bankCode' },
            { label: 'ValueDate', value: 'ValueDate' },
            { label: 'FavourName', value: 'FavourName' },
            { label: 'Remarks', value: 'remarks' },
            { label: 'FundingAccount', value: 'FundingAccount' },
            { label: 'PaymentRequestError', value: 'PaymentRequestError' },
            { label: 'ByAgent', value: 'byAgent' },
            { label: 'VerificationReason', value: 'verificationReason' },
            { label: 'ConfirmRejectStatus', value: 'confirmRejectStatus' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }
  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
    setDedupeChecked(false);
  }

  function handleDedupe(_e: CheckboxChangeEvent) {
    const checked = _e.target.checked;
    setDedupeChecked(checked);
    if (checked) {
      form.setFieldsValue({
        FromDate: null,
        ToDate: null,
      });
    }
  }
  const memoizedFilter = useMemo(() => filter, [filter]);
  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box" style={{ width: '100%' }}>
              <h2>Agent Receipt Dashboard</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<ReceiptPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Loan Number :'} name="LANumber" className="fieldTitle">
                          <Input placeholder={'Loan Number'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Purpose :'}
                          name="PaymentPurpose"
                          className="fieldTitle"
                        >
                          {/* <Input placeholder={'Payment Response'} /> */}
                          <Select placeholder="Select" size="large">
                            <option value="ADVANCEEMI">ADVANCEEMI</option>
                            <option value="Crossell">Crossell</option>
                            <option value="Fees">Fees</option>
                            <option value="Foreclosure">Foreclosure</option>
                            <option value="OtherCharges">OtherCharges</option>
                            <option value="Overdue">Overdue</option>
                            <option value="OverdueWithoutCharges">OverdueWithoutCharges</option>
                            <option value="PartPayment">PartPayment</option>
                            <option value="VAS">VAS</option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Request ID :'}
                          name="PaymentRequestId"
                          className="fieldTitle"
                          validateStatus={onlyDigitError ? 'error' : ''}
                          help={onlyDigitError ? 'Only numbers are allowed' : ''}
                        >
                          <InputNumber
                            value={form.getFieldValue('PaymentRequestId')}
                            onBeforeInput={(e) => handleOnlyNumber(e, setOnlyDigitError)}
                            placeholder={'Payment Request ID:'}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Request Date From :'}
                          name="FromDate"
                          className="fieldTitle"
                        >
                          <DatePicker format={dateFormat} disabled={isDedupeChecked} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'To :'} name="ToDate" className="To">
                          <DatePicker format={dateFormat} disabled={isDedupeChecked} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      {/* <Form.Item
                        name="IsDedupe"
                        className="IsDedupe"
                        style={{ marginLeft: '15px', fontSize: '18px' }}
                      >
                        Dedupe Flag :{' '}
                        <Checkbox style={{ marginTop: '40px' }} onChange={handleDedupe}></Checkbox>
                      </Form.Item> */}
                      <Form.Item
                        name="includeArchived"
                        className="IsDedupe"
                        valuePropName="checked"
                        style={{ marginLeft: '15px', fontSize: '18px' }}
                      >
                        Dedupe Flag :{' '}
                        <Checkbox
                          style={{ marginTop: '40px' }}
                          onChange={handleDedupe}
                          checked={isDedupeChecked}
                        ></Checkbox>
                      </Form.Item>
                    </div>
                  </div>
                  {isDedupeChecked ? (
                    <div className="row">
                      <div className="col-xs-12 col-sm-4 col-md-4">
                        <div className="input-box">
                          <Form.Item
                            label={'Dedupe Date From :'}
                            name="DedupeFromDate"
                            className="fieldTitle"
                          >
                            <DatePicker format={dateFormat} />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-4 col-md-4">
                        <div className="input-box">
                          <Form.Item label={'To :'} name="DedupeToDate" className="To">
                            <DatePicker format={dateFormat} />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-4 col-md-4">
                        <Form.Item
                          label={'Status :'}
                          name="ConfirmRejectStatus"
                          className="Status"
                          style={{ marginLeft: '15px', fontSize: '18px' }}
                        >
                          <Select placeholder="Select" size="large">
                            <Option value="CONFIRMATION_REQUIRED">CONFIRMATION_REQUIRED</Option>
                            <Option value="CONFIRMED">CONFIRMED</Option>
                            <Option value="REJECTED">REJECTED</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  ) : null}
                  <div className="row">
                    <div className="col-xs-12 col-sm-8 col-md-8">
                      <h5>Note: To use dedupe filters select Dedupe flag.</h5>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <Button
                        type="link"
                        icon={<FileExcelFilled />}
                        style={{ float: 'right', fontSize: '30px', color: 'green' }}
                        onClick={handleDownload}
                      ></Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        onClick={handleReset}
                        style={{ float: 'right', marginBottom: '15px', marginLeft: '10px' }}
                      >
                        {'CLEAR'}
                      </Button>

                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ float: 'right', marginBottom: '15px' }}
                      >
                        {'SEARCH'}
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
              {/* ReceiptList Here */}
              <AgentReceiptList filter={memoizedFilter} setOnlyDigitError={setOnlyDigitError} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentReceiptDashboard;
